import { useEffect, useState } from "react";
import { DELETE_COMPONENT, TOGGLE_DELETE_COMPONENT_DIALOG, TOGGLE_RESET_COMPONENT_DIALOG } from "../../../Context/Display/Components/ComponentsContextEvents";
import RemoveDialog from "../../Shared/Remove/RemoveDialog";
import useComponents, { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { createComponent, deleteComponent, resetComponent } from "../../../API/Display/Display";
import usePages, { useUpdatePageComponent } from "../../../Hooks/Display/usePages";
import { getPageFromPages } from "../utils";
import { getComponentByProperty } from "./utils";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";

function ResetComponentDialog() {

    const [{ pages, selectedPageIndex }] = usePages();
    const [{ components, selectedComponentIndex }, dispatchComponentEvent] = useComponents();

    const [component, setComponent] = useState({});

    const entityName = usePropsStoreValue("entityName");
    const selectedPage = getPageFromPages(pages, selectedPageIndex);
    const updatePageComponent = useUpdatePageComponent(selectedPage.parentId, selectedPage._id);

    useEffect(() => {
        if (!selectedComponentIndex) {
            setComponent({});
            return;
        }
        const component = getComponentByProperty(components, "treeIndex", selectedComponentIndex);
        setComponent(component);
    }, [selectedComponentIndex])

    function toggleResetDialog() {
        dispatchComponentEvent({
            type: TOGGLE_RESET_COMPONENT_DIALOG
        })
    }

    async function handleReset() {
        debugger;
        const { data: newComponent } = await resetComponent(selectedPage._id, component.id, entityName);
        updatePageComponent(component.id, newComponent);
        toggleResetDialog();
    }

    return (
        <RemoveDialog
            Title="Reset component"
            toggleDeleteDialog={toggleResetDialog}
            message={`Are you sure you want to reset the ${component.componentName} component?`}
            onDelete={handleReset}
            onCancel={toggleResetDialog}
            deleteButtonText="Reset" />
    )
}

export default ResetComponentDialog;